var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Execution",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA-New-UI",
    transform: "translate(-332.000000, -854.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/12px/Status/Error",
    transform: "translate(332.000000, 854.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FAAF00",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.000000, 4.500000) rotate(-90.000000) translate(-6.000000, -4.500000) ",
    x: 3.5,
    y: 3.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.000000, 9.000000) rotate(-90.000000) translate(-6.000000, -9.000000) ",
    x: 5,
    y: 8,
    width: 2,
    height: 2,
    rx: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.afbd2e381a086e6d05fedb241b9832e0.svg";
export { ForwardRef as ReactComponent };